import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useMemo, useState } from 'react';
import { isError, isFailure } from '@atlassian/commerce-credit-card-base';
import { useCommerceFetch } from '@atlassian/commerce-environment';
import { getStripeKey } from '../requests';
var createSetters = function createSetters(setTokenHookResponse) {
  return {
    error: function error(_error) {
      return setTokenHookResponse({
        state: 'error',
        error: _error
      });
    },
    complete: function complete(payload) {
      return setTokenHookResponse({
        state: 'complete',
        payload: payload
      });
    }
  };
};
var useTokenResponseState = function useTokenResponseState() {
  var _useState = useState({
      state: 'loading',
      payload: undefined
    }),
    _useState2 = _slicedToArray(_useState, 2),
    tokenHookResponse = _useState2[0],
    setTokenHookResponse = _useState2[1];
  var setters = useMemo(function () {
    return createSetters(setTokenHookResponse);
  }, [setTokenHookResponse]);
  return [tokenHookResponse, setters];
};
var failureResultToErrorMessage = function failureResultToErrorMessage(response) {
  return isError(response) ? response.error.errorDetail : response.exception.message;
};
export var useHAMSTokenServiceHookWithUrl = function useHAMSTokenServiceHookWithUrl(stripeKeyUrl) {
  var _useTokenResponseStat = useTokenResponseState(),
    _useTokenResponseStat2 = _slicedToArray(_useTokenResponseStat, 2),
    token = _useTokenResponseStat2[0],
    setters = _useTokenResponseStat2[1];
  var fetch = useCommerceFetch();
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var keyResult, compiledErrorMessage, _keyResult$payload, publishableKey, gateway;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getStripeKey(fetch, stripeKeyUrl);
          case 3:
            keyResult = _context.sent;
            if (!isFailure(keyResult)) {
              _context.next = 8;
              break;
            }
            compiledErrorMessage = failureResultToErrorMessage(keyResult);
            setters.error(compiledErrorMessage);
            return _context.abrupt("return");
          case 8:
            _keyResult$payload = keyResult.payload, publishableKey = _keyResult$payload.publishableKey, gateway = _keyResult$payload.gateway;
            if (!(publishableKey === undefined)) {
              _context.next = 12;
              break;
            }
            setters.error('Received invalid public key responses');
            return _context.abrupt("return");
          case 12:
            setters.complete({
              publicKey: publishableKey,
              hams: {
                gateway: gateway
              }
            });
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            setters.error(_context.t0 instanceof Error ? _context.t0.message : String(_context.t0));
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 15]]);
    }))();
  }, [stripeKeyUrl, setters, fetch]);
  return token;
};